export const Work = [
    {
        id:1,
        name:"NFTify",
        description:"It is build on top of the React JS, with styledComponents and dexscreen NFT API.",
        tags:["react","dexscreen","styledComponents"],
        
        demo:"https://nftify-ayush.netlify.app/",
        github:"https://github.com/OneAutumLeaf/nftify-res"
    },
    {
        id:2,
        name:"ALAN AI News App",
        description:"A news listing website build in ReactJS. With searching and ALAN AI interactive functionalities.",
        tags:["react","ALAN AI", "api"],
        
        demo:"https://newsalan.netlify.app/",
        github:"https://github.com/OneAutumLeaf/Alan-News"
        
    },
    {
        id:3,
        name:"DriveX",
        description:"A car admin dashboard build using ReactJS. With material Ui icons, components chart and graphs.",
        tags:["react","ChartJS","sass"],
        
        demo:"https://drivex12.netlify.app/",
        github:"https://github.com/OneAutumLeaf/DriveX"
    },
    {
        id:4,
        name:"GPT-3",
        description:"A cool looking GPT-3 website using ReactJS and styledComponents.It has really cool icons and Figma designs.",
        tags:["react","styledComponents","react-router"],
        
        demo:"https://github.com/OneAutumLeaf/GPT-3",
        github:"https://github.com/OneAutumLeaf/GPT-3"
       
    },{
        id:5,
        name:"HealFit",
        description:"A fitness and health app build using react and styledComponents.",
        tags:["react","fitness","health"],
        
        demo:"https://github.com/OneAutumLeaf/HealFit",
        github:"https://github.com/OneAutumLeaf/HealFit"
        
    },
    
    
  
] 